import Vue from 'vue';
import VueRouter from 'vue-router';
import Search from './components/search.vue';
import List from './components/list.vue';
import Axios from 'axios';
import qs from 'qs';

if (!global._babelPolyfill) {
    require('babel-polyfill');
}

Vue.use(VueRouter);

const router = new VueRouter();
const VueInstance = new Vue({
	el: '#shimbaselinefinder',
	router,
	data() {
		return {
			config: SHIM_BASELINE_FINDER_CONFIG,
			loading: false,
            error: '',
			fetchedData: false,
			list: [ ]
		};
	},
    mounted() {
        if(Object.entries(this.queryData).length > 0) {
            this.onSubmit(this.queryData);
        }
    },
	methods: {
		onSubmit(data) {
			if (JSON.stringify(data) != JSON.stringify(this.queryData)) {
				this.$router.push({
					query: data
				});
			}

            this.error = '';
			this.loading = true;
			this.list = [ ];
			Axios.post(
				this.config.api_url,
				qs.stringify({
					action: this.config.action_name,
					search: data
				})
			)
				.then((res) => {
					this.fetchedData = true;
					this.list = res.data;
					this.loading = false;
					
					this.$nextTick(() => {
						jQuery(".fancybox").fancybox();
					})
				})
				.catch(err => {
					this.loading = false;
					console.error(err);
                    if(err.response && err.response.data) {
                        this.error = err.response.data.data.error;
                    } 
				});
		}
	},
	computed: {
		queryData() {
			let data = {};
			for (let i in this.$route.query) {
				if (this.$route.query[i] == 'true' || this.$route.query[i] === true) {
					data[i] = true;
				} else if (!isNaN(parseFloat(this.$route.query[i]))) {
					data[i] = parseFloat(this.$route.query[i]);
				}
			}

			return data;
		}
	},
	components: {
		Search,
		List
	}
});
